<template lang="pug">
  .component-vehicle-hardware-reveal-create
    modal-reveal(sizing="small", ref="modalAddVehicleHardware")
      button.button.small(slot="trigger") Add Vehicle Hardware
      h2 Add new Vehicle hardware
      label Vehicle V{{item.id}} {{item.brand}} {{item.model}}


      .row
        .column

          label Manager
            select(v-model="manager")
              option(v-for="(manager, index) in managers") {{index}}
        .column
          label Serial
            input(type="text" v-model="body.serial")
      .row
        .column
          label Extra
          array-edit(:values="body.extra")

          button.button(@click="addHardware") Add Hardware
</template>

<script>
  import ModalReveal from "../../../foundation/ModalReveal";
  import KeplerBackofficeSdk from "../../../../../lib/kepler/backoffice";
  import MaggieHelper from "../../../../../maggieHelper";
  import ArrayEdit from "../../ArrayEdit";

  export default {
    name: "VehicleHardwareRevealCreate",
    components: {ArrayEdit, ModalReveal},
    methods: {
      addHardware() {

        this.body.manager = this.managers[this.manager]

        KeplerBackofficeSdk.vehicleHardware.make(this.body, (data) => {
          this.$refs.modalAddVehicleHardware.close()
          MaggieHelper.notification('create-esit', 'Vehicle hardware created successfully')
          this.$emit('update')
        })
      }
    },
    data() {
      return {
        managers: null,
        manager: null,

        body: {
          vehicle_id: this.item.id,
          serial: null,
          manager: null,
          extra: {}
        }
      }
    },
    created() {
      KeplerBackofficeSdk.vehicleHardware.list.managers((data) => {
        this.managers = data
      })
    },
    props: ['item']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// VehicleHardwareRevealCreate.vue?90ba2344